
export default function ResultsSection() {
  const stats = [
    {
      number: '300%',
      label: '応募数増加',
      description: '平均的な応募数向上率'
    },
    {
      number: '50%',
      label: 'コスト削減',
      description: '採用1名あたりのコスト'
    },
    {
      number: '2週間',
      label: '採用期間短縮',
      description: '従来比での期間短縮'
    },
    {
      number: '95%',
      label: '継続利用率',
      description: 'お客様満足度'
    }
  ];

  return (
    <section className="py-20 bg-blue-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-6">
            <span className="text-blue-600">確かな実績</span>でお客様の採用を成功に導いています
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            運送業界での豊富な実績と専門ノウハウで、多くの企業様の採用課題を解決してきました
          </p>
        </div>

        {/* 数値実績 */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center bg-white rounded-xl p-8 shadow-lg">
              <div className="text-4xl font-bold text-blue-600 mb-2">{stat.number}</div>
              <div className="text-lg font-semibold text-gray-800 mb-2">{stat.label}</div>
              <div className="text-sm text-gray-600">{stat.description}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
